import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/screenshots/mazii_logo.png'
import _imports_1 from '../../assets/img/icons/apple-store.svg'
import _imports_2 from '../../assets/img/icons/google-play.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar-wrapper d-flex align-items-center" }
const _hoisted_3 = {
  id: "navbar",
  class: "navbar"
}
const _hoisted_4 = { class: "navbar-collapse d-flex justify-content-center" }
const _hoisted_5 = { class: "navbar-nav md-none" }
const _hoisted_6 = { class: "nav-item has-child" }
const _hoisted_7 = { class: "dropdown-menu has-child bg-white" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    id: "navbar-wrap",
    class: _normalizeClass(['navbar-area', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "logo-light",
              src: _imports_0,
              alt: "Image"
            }, null, -1),
            _createElementVNode("img", {
              class: "logo-dark",
              src: _imports_0,
              alt: "Image"
            }, null, -1)
          ])),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "other-options d-flex align-items-center ms-auto d-lg-none" }, [
          _createElementVNode("div", { class: "app-btn d-flex align-items-center justify-content-end" }, [
            _createElementVNode("a", {
              href: "https://apps.apple.com/vn/app/mazii-couple-live-widget/id6738032649",
              class: "d-flex flex-column justify-content-center align-items-center rounded-circle",
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Image"
              })
            ]),
            _createElementVNode("a", {
              href: "https://play.google.com/store/apps/details?id=com.dtalabs.togethersnap",
              class: "d-flex flex-column justify-content-center align-items-center rounded-circle",
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Image"
              })
            ])
          ]),
          _createElementVNode("a", {
            class: "navbar-toggler d-lg-none",
            "data-bs-toggle": "offcanvas",
            href: "#navbarOffcanvas",
            role: "button",
            "aria-controls": "navbarOffcanvas"
          }, [
            _createElementVNode("span", { class: "burger-menu" }, [
              _createElementVNode("span", { class: "top-bar" }),
              _createElementVNode("span", { class: "middle-bar" }),
              _createElementVNode("span", { class: "bottom-bar" })
            ])
          ])
        ], -1)),
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _cache[5] || (_cache[5] = _createStaticVNode("<li class=\"nav-item\" data-v-452b6930><a class=\"nav-link\" href=\"#hero-area\" data-v-452b6930>Home</a></li><li class=\"nav-item\" data-v-452b6930><a class=\"nav-link\" href=\"#about-area\" data-v-452b6930>Why Mazii</a></li><li class=\"nav-item\" data-v-452b6930><a class=\"nav-link\" href=\"#testimonials-area\" data-v-452b6930>What Couples Say</a></li><li class=\"nav-item\" data-v-452b6930><a class=\"nav-link\" href=\"#hw-area\" data-v-452b6930>More special features</a></li>", 4)),
              _createElementVNode("li", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("a", {
                  href: "javascript:void(0)",
                  class: "dropdown-toggle"
                }, " Pages ", -1)),
                _createElementVNode("ul", _hoisted_7, [
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, { to: "/faq" }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("FAQ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, [
                    _createVNode(_component_router_link, { to: "/terms-conditions" }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" Terms & Conditions ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_10, [
                    _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Privacy Policy ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"app-btn d-flex align-items-center justify-content-end ms-auto md-none\" data-v-452b6930><a href=\"https://apps.apple.com/vn/app/mazii-couple-live-widget/id6738032649\" target=\"_blank\" class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" data-v-452b6930><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-452b6930></a><a href=\"https://play.google.com/store/apps/details?id=com.dtalabs.togethersnap\" target=\"_blank\" class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" data-v-452b6930><img src=\"" + _imports_2 + "\" alt=\"Image\" data-v-452b6930></a></div>", 1))
      ])
    ])
  ], 2))
}